module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAUCAYAAACEYr13AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAABgSURBVDiN7ZIxEYAwEAT3oiASkERmYgAJKEECBlIgCQlR8E8TBspQk6tudttVKWWWtAHR3Zec8wHQy4OkHZiA2AQAvTwAlWfx9bt4cPe1wdPM0m2+8j9Po4PRAaMDM0sXwtulZ35GHIkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/public/components/kye-data-statistic/images/draggable-icon.png
// module id = RylY
// module chunks = 6